//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast} from 'vue-ydui/dist/lib.rem/dialog';
import {getDetail} from '@/api/whk';
import axios from 'axios';
export default {
  data() {
    return {
      userInfo:{},
      content:'',
      list:[],
      businessesPhone:''
    };
  },

  methods: {
    toDetail(item){
      //先验证是否有库存

      let params = {id: item.id}
      getDetail(params).then((res) => {
        if(res.data.stock > 0) {
          this.$router.push({ path: '/whk/userLogin', query: { commodityId: item.id,thumbnail: item.thumbnail,businessesPhone:this.businessesPhone}});
        }else{
          this.content = "库存不足";
          this.showToast(this.content,1500,'error');
        }
      })

    },
    getList(){
      axios({
        method: "POST",
        url: 'https://ypapp.cnnb.com.cn/web-nbcc/commodity/commodity/list2', //填写接口地址  全路径
        headers: {'ticket': this.userInfo.ticket,
                  'module':'web-member'
        }
      }).then((res) => {
        if(res.code == 0 ){
          this.list = res.data;
        }else if(res.code == 401){
          this.content = "请重新登录";
          this.showToast(this.content,1500,'error');
          this.$router.push({ path: '/whk/businesses', query: { sign: 1}});
        }else{
          this.content = res.message;
          this.showToast(this.content,1500,'error');
        }

      });
    },
    showToast(content,timeout,icon){
      this.$dialog.toast({
        mes: content,
        timeout: timeout,
        icon: icon,
      });
    },


  },
  mounted () {
    this.businessesPhone = this.$route.query.businessesPhone;
    var json = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(json);
    this.getList();
  }
};



// WEBPACK FOOTER //
// ./src/pages/whk/product_list.vue